import { useDispatch, useSelector } from "react-redux";
import NoDataImg from "../../../assets/img/no-data.gif";
import * as React from "react";
import NavBar from "../../structure/NavBar";
import { NavBarTop } from "../../structure/NavBarTop";
import VerifiedIcon from "@mui/icons-material/Verified";
import ReplyIcon from "@mui/icons-material/Reply";
import {
  updateTopHeader,
  uplodateLoading,
} from "../../../redux/features/common/commonSlice";
import { useEffect, useState, useRef } from "react";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
// import { showDangerToast } from "../../constants/toaster";
import { useNavigate, useParams, useLocation } from "react-router-dom"; // ranith 2025-12-06 - [Start] - [Import useLocation]
import { PlayVideoInModal } from "../../custom/PlayVideoInModal";
import Utils from "../../constants/Utils";
import { formatIndianNumber } from "../../lib/formatIndianNumber";
import { getWithdrawTxnId } from "../../lib/withdrawDisplay";
import { FullImageView } from "../../custom/FullImageView";
import { InvitedUserList } from "./InvitedUserList";
import { UserFeedDiagnostics } from "./UserFeedDiagnostics";
import {
  buildTabCacheKey,
  getTabCache,
  setTabCache,
  clearTabCacheForUser,
} from "../../lib/tabFetchCache";

import StarIcon from "@mui/icons-material/Star";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { SendUserNotificationModal } from "./SendUserNotificationModal";
import { SendUserWhatsAppModal } from "./SendUserWhatsAppModal";



import {

  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  Stack,
  Grid,
  Box,
  Tabs,
  Tab,
  IconButton,
  Divider,
  Badge,
  Container,
  ButtonGroup
} from '@mui/material';

import { Select, MenuItem } from '@mui/material';
import { showDangerToast } from "../../constants/toaster";
import { showToast } from "../../constants/toaster";

import {
  Favorite,
  Comment,
  Share,
  Visibility,
  Flag,
  People,
  VideoLibrary,
  EmojiEvents,
  Email,
  Phone,
  Cake,
  AccountCircle,
  Settings,
  Edit,
  Grade,
  PersonAdd,
  AccountBalanceWallet,
  AccessTime,
} from '@mui/icons-material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { v4 as uuidv4 } from 'uuid';

export const UserDetails = () => {

  const { formatDate, formatDateTime } = Utils();
  const router = useNavigate();
  // ranith 2025-12-06 - [Start] - [Capture location state]
  const location = useLocation();
  // ranith 2025-12-06 - [End] - [Capture location state]
  const [showPlayVideoModal, setShowPlayVideoModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);

  const getVideoPlayableList = () =>
    (recentUserVideos || []).filter((v) => v?.link);

  const openVideoAtIndex = (index) => {
    const list = getVideoPlayableList();
    if (!list.length || index < 0 || index >= list.length) return;
    setActiveVideoIndex(index);
    setVideoSrc(list[index].link);
    setShowPlayVideoModal(true);
  };

  const handleVideoIndexChange = (index) => {
    const list = getVideoPlayableList();
    if (!list.length || index < 0 || index >= list.length) return;
    setActiveVideoIndex(index);
    setVideoSrc(list[index].link);
  };

  const closeVideoModal = () => {
    setShowPlayVideoModal(false);
    setVideoSrc("");
  };
  const [userDetailsData, setUserDetailsData] = useState({});
  const [recentUserVideos, setRecentUserVideos] = useState([]);
  const userData = useSelector((state) => state?.userData);
  const adminUserNameHeader =
    userData?.email || userData?.emailId || userData?.userName || ''
  const videoApiHeaders = adminUserNameHeader
    ? { userName: adminUserNameHeader }
    : {}
  const [imageUrl, setImageUrl] = useState(false);
  const [fullSizePreview, setFullSizePreview] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState(0); // ✅ default tab
  // const [invitedListType, setInvitedListType] = useState(null);
  const [referralCodes, setReferralCodes] = useState({
    referralCode: null,
    cashReferralCode: null,
  });
  const [referralCodesLoading, setReferralCodesLoading] = useState(false);
  const referralCodesFetchedRef = useRef(false);

  const resolveReferralCodes = (data = {}) => {
    const referralCode =
      data?.referralCode ||
      data?.referral_code ||
      data?.userReferralCode ||
      null;
    const cashReferralCode =
      data?.cashReferralCode ||
      data?.cash_referral_code ||
      data?.creatorReferralCode ||
      data?.createrReferralCode ||
      data?.creator_referral_code ||
      data?.creater_referral_code ||
      null;

    return { referralCode, cashReferralCode };
  };

  const getCashWalletBalance = (data = userDetailsData) =>
    data?.cashWalletBalance ?? data?.cash_wallet_balance ?? 0;

  const getInvitedByName = (data = userDetailsData) => {
    if (!data) return '';
    if (typeof data.invitedBy === 'string' && data.invitedBy.trim()) return data.invitedBy.trim();
    return (
      data.invitedByName ||
      data.invited_by_name ||
      data.invitedByUserName ||
      data.invited_by_user_name ||
      data.invitedByFullName ||
      data.referrerName ||
      data.referrerUserName ||
      data.referredByName ||
      data.inviterName ||
      data.invitedBy?.fullName ||
      data.invitedBy?.userName ||
      data.invitedBy?.name ||
      ''
    );
  };

  const getInvitedByUserId = (data = userDetailsData) =>
    data?.invitedByUserId ||
    data?.invited_by_user_id ||
    data?.invitedById ||
    data?.invited_by_id ||
    data?.invitedBy?.id ||
    data?.invitedBy?.userId ||
    null;

  const profileStatSx = {
    value: {
      fontWeight: 700,
      lineHeight: 1.2,
      fontSize: { xs: '0.95rem', sm: '1.1rem' },
      whiteSpace: 'nowrap',
    },
    label: {
      display: 'block',
      mt: 0.25,
      color: 'text.secondary',
      fontSize: { xs: '0.65rem', sm: '0.7rem' },
      lineHeight: 1.2,
    },
  };

  // const getReferralCodeForInviteType = (codes, inviteType) => {
  //   if (inviteType === 'CREATERINVITE') {
  //     return codes?.cashReferralCode || codes?.referralCode || null;
  //   }
  //   return codes?.referralCode || null;
  // };
  const [grades, setGrades] = useState([]);
  // This state will now store the grade ID
  const [selectedGrade, setSelectedGrade] = useState("");


  useEffect(() => {
    dispatch(updateTopHeader("User Manager"));
    referralCodesFetchedRef.current = false;
    clearTabCacheForUser(id);
    setAppActivityPage(0);
    setAppActivityItems([]);
    setAppActivityTotalTime(null);
    if (id) {
      getUserDetails();
      getUserRecentVideos();
    }
  }, [id]);

  useEffect(() => {
    if (location.state?.referralCode || location.state?.cashReferralCode) {
      setReferralCodes((prev) => ({
        referralCode: location.state?.referralCode || prev.referralCode,
        cashReferralCode: location.state?.cashReferralCode || prev.cashReferralCode,
      }));
    }
  }, [location.state]);

  const fetchReferralCodesFromList = async () => {
    if (!id || !userData?.access_token) return;

    const codesCacheKey = buildTabCacheKey(id, 'referral-codes');
    const cachedCodes = getTabCache(codesCacheKey);
    if (cachedCodes) {
      setReferralCodes(cachedCodes);
      referralCodesFetchedRef.current = true;
      return;
    }

    const searchKey =
      userDetailsData?.userName ||
      userDetailsData?.email ||
      userDetailsData?.contactNumber ||
      '';

    if (!searchKey) return;

    try {
      setReferralCodesLoading(true);
      const postJson = {
        searchText: String(searchKey).trim(),
        active: '',
        subscription: '',
        kycStatus: '',
        isGrade: null,
        pageNumber: 0,
        pageSize: 50,
        shortingField: 'createdAt',
        asc: true,
        paid: false,
        startDate: '',
        endDate: '',
      };

      const res = await ApiCaller.post(postJson, urls.userList, userData?.access_token);
      const response = await res.response.json();

      if (response.status == 200) {
        const items =
          response?.data?.response?.items ||
          response?.data?.items ||
          [];
        const match = items.find((u) => String(u?.id) === String(id));

        if (match) {
          const codes = resolveReferralCodes(match);
          setReferralCodes(codes);
          setTabCache(codesCacheKey, codes);
          referralCodesFetchedRef.current = true;
        }
      }
    } catch (error) {
      console.error('Error fetching referral codes:', error);
    } finally {
      setReferralCodesLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab !== 4) return;
    if (referralCodesFetchedRef.current) return;

    const fromDetails = resolveReferralCodes(userDetailsData);
    if (fromDetails.referralCode || fromDetails.cashReferralCode) {
      setReferralCodes((prev) => ({
        referralCode: fromDetails.referralCode || prev.referralCode,
        cashReferralCode: fromDetails.cashReferralCode || prev.cashReferralCode,
      }));
      setTabCache(buildTabCacheKey(id, 'referral-codes'), fromDetails);
      referralCodesFetchedRef.current = true;
      return;
    }

    if (referralCodes.referralCode || referralCodes.cashReferralCode) {
      referralCodesFetchedRef.current = true;
      return;
    }

    fetchReferralCodesFromList();
  }, [activeTab, id, userDetailsData]);

  useEffect(() => {
    const fetchGrades = async () => {
      try {
        dispatch(uplodateLoading(true));

        const token = userData?.access_token;
        if (!token) {
          showDangerToast("Access token missing. Please login again.");
          dispatch(uplodateLoading(false));
          return;
        }

        // ✅ API path only (ApiCaller adds base URL automatically)
        const path = "/api/admin-service/grades/grade-list";

        // ✅ POST body
        const body = {};

        // ✅ Correct ApiCaller usage → (body, path, token)
        const res = await ApiCaller.post(body, path, token);
        const response = res?.response ? await res.response.json() : null;

        console.log("Get All Grades API Response:", response);

        if (response?.status === 200 || response?.status === "200" || response?.successful) {
          const data = response?.data || [];
          setGrades(data);
          dispatch(uplodateLoading(false));
        } else {
          showDangerToast(response?.message || "Failed to fetch grades");
          dispatch(uplodateLoading(false));
        }
      } catch (error) {
        dispatch(uplodateLoading(false));
        console.error("Error fetching grades:", error);
        showDangerToast(error?.message || "Error fetching grade data");
      }
    };


    fetchGrades();
  }, []);


  const getUserDetails = async (silent = false) => {
    try {
      if (!silent) dispatch(uplodateLoading(true))
      let path = urls.userDetails + '/' + id
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()

      if (response?.status == 200 || response?.status === '200' || response?.successful || response?.success) {
        const data = response?.data || response
        setUserDetailsData(data)
        setReferralCodes(resolveReferralCodes(data))

        // Set the initial selected grade using the user's gradeId
        if (data?.gradeId != null) {
          setSelectedGrade(data.gradeId);
        } else {
          setSelectedGrade("");
        }
      } else {
        showDangerToast(response?.message || "Failed to fetch user details")
      }
    } catch (error) {
      console.error("Error fetching user details:", error)
      showDangerToast(error.message)
    } finally {
      if (!silent) dispatch(uplodateLoading(false))
    }
  }


  const [searchText, setSearchText] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [statusDropdownText, setStatusDropdownText] = useState('Select Status');
  const [mediaDropDownText, setMediaDropDownText] = useState('VIDEO');
  const [activeInActiveStatus, setActiveInActiveStatus] = useState(true);
  const [page, setPage] = useState(1);
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 12,
    totalPages: 1,
  });
  const [callAPi, setCallAPi] = useState('');

  // ADDED: Bank & Withdrawals tab preview (Beads + Cash)
  const [chipsTxnPreview, setChipsTxnPreview] = useState([]);
  const [cashTxnPreview, setCashTxnPreview] = useState([]);
  const [bankTxnPreview, setBankTxnPreview] = useState([]);
  const [chipsTxnPreviewLoading, setChipsTxnPreviewLoading] = useState(false);
  const [cashTxnPreviewLoading, setCashTxnPreviewLoading] = useState(false);
  const [bankTxnPreviewLoading, setBankTxnPreviewLoading] = useState(false);

  const [appActivityItems, setAppActivityItems] = useState([]);
  const [appActivityTotalTime, setAppActivityTotalTime] = useState(null);
  const [appActivityLoading, setAppActivityLoading] = useState(false);
  const [appActivityPage, setAppActivityPage] = useState(0);
  const [appActivityPagination, setAppActivityPagination] = useState({
    totalItems: 0,
    pageNumber: 0,
    pageSize: 10,
    totalPages: 1,
  });

  const formatAppTimeParts = (timeParts) => {
    if (!timeParts) return '0m';
    const hours = Number(timeParts.hours) || 0;
    const minutes = Number(timeParts.minutes) || 0;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
  };

  const fetchUserAppActivity = async (page = 0) => {
    if (!id || !userData?.access_token) return;
    try {
      setAppActivityLoading(true);
      const postJson = {
        userId: id,
        page,
        limit: 10,
      };
      const res = await ApiCaller.post(
        postJson,
        urls.userActivityAdminList,
        userData?.access_token,
        adminUserNameHeader ? { userName: adminUserNameHeader } : {}
      );
      const response = await res.response.json();
      if (response?.status === '200' || response?.status === 200) {
        const data = response?.data || {};
        const daily = data.dailyActivity || {};
        setAppActivityItems(Array.isArray(daily.items) ? daily.items : []);
        setAppActivityTotalTime(data.totalTime || null);
        setAppActivityPagination({
          totalItems: daily.totalItems ?? 0,
          pageNumber: daily.pageNumber ?? page,
          pageSize: daily.pageSize ?? 10,
          totalPages: daily.totalPages ?? 1,
        });
      } else {
        showDangerToast(response?.message || 'Failed to fetch app usage activity');
        setAppActivityItems([]);
        setAppActivityTotalTime(null);
      }
    } catch (error) {
      console.error('Error fetching app activity:', error);
      showDangerToast(error?.message || 'Failed to fetch app usage activity');
      setAppActivityItems([]);
      setAppActivityTotalTime(null);
    } finally {
      setAppActivityLoading(false);
    }
  };

  const walletEmail = userDetailsData?.email || userDetailsData?.userName || '';

  const isReceivedTxn = (item) => {
    const type = String(item?.transactionType || item?.type || '').toUpperCase();
    return /CREDIT|RECEIVED|IN|ADD|RECEIVE|CR/.test(type);
  };

  const getTxnAmount = (item) => {
    const amountVal =
      item?.amount !== undefined && item?.amount !== null
        ? item?.amount
        : item?.beads !== undefined && item?.beads !== null
          ? item?.beads
          : 0;
    const num = Number(amountVal);
    return formatIndianNumber(num);
  };

  useEffect(() => {
    if (activeTab !== 3) return;
    if (!walletEmail) return;
    if (!userData?.access_token) return;

    const bankCacheKey = buildTabCacheKey(id, 'bank-withdrawals', walletEmail);
    const cachedBank = getTabCache(bankCacheKey);
    if (cachedBank) {
      setChipsTxnPreview(cachedBank.chips || []);
      setCashTxnPreview(cachedBank.cash || []);
      setBankTxnPreview(cachedBank.bank || []);
      setChipsTxnPreviewLoading(false);
      setCashTxnPreviewLoading(false);
      setBankTxnPreviewLoading(false);
      return;
    }

    let cancelled = false;

    const fetchPreview = async () => {
      try {
        setChipsTxnPreviewLoading(true);
        setCashTxnPreviewLoading(true);
        setBankTxnPreviewLoading(true);

        const commonPostJson = {
          sort: 'createdAt',
          order: false,
          page: 0,
          limit: 10,
          txnId: '',
          toUserId: '',
          transactionType: 'ALL',
          startDate: undefined,
          endDate: undefined
        };

        const chipsUrl = `${urls.viewUserTransactions}?email=${encodeURIComponent(walletEmail)}`;
        const cashUrl = `${urls.viewUserCashTransactions}?email=${encodeURIComponent(walletEmail)}`;

        const bankPostJson = {
          sort: 'createdAt',
          order: false,
          page: 0,
          limit: 10,
          txnId: '',
          search: '',
          startDate: null,
          toUserId: id,
          endDate: null,
          status: 'ALL'
        };

        const [chipsRes, cashRes, bankRes] = await Promise.all([
          ApiCaller.post(commonPostJson, chipsUrl, userData?.access_token),
          ApiCaller.post(commonPostJson, cashUrl, userData?.access_token)
          ,
          ApiCaller.post(bankPostJson, urls.bankWithdrawHistory, userData?.access_token)
        ]);

        const chipsResponse = await chipsRes.response.json();
        const cashResponse = await cashRes.response.json();
        const bankResponse = await bankRes.response.json();

        const chipsApiData =
          chipsResponse?.data && chipsResponse?.data?.data
            ? chipsResponse.data.data
            : chipsResponse?.data
              ? chipsResponse.data
              : chipsResponse;
        const cashApiData = cashResponse?.data?.data || cashResponse?.data || cashResponse;

        const bankApiData = bankResponse.data?.data || bankResponse.data || bankResponse;

        if (!cancelled) {
          const chips = Array.isArray(chipsApiData?.items) ? chipsApiData.items : [];
          const cash = Array.isArray(cashApiData?.items) ? cashApiData.items : [];
          const bank = Array.isArray(bankApiData?.items)
            ? bankApiData.items
            : Array.isArray(bankApiData?.records)
              ? bankApiData.records
              : [];

          setChipsTxnPreview(chips);
          setCashTxnPreview(cash);
          setBankTxnPreview(bank);
          setTabCache(bankCacheKey, { chips, cash, bank });
        }
      } catch (e) {
        if (!cancelled) showDangerToast(e?.message || 'Something went wrong');
      } finally {
        if (!cancelled) {
          setChipsTxnPreviewLoading(false);
          setCashTxnPreviewLoading(false);
          setBankTxnPreviewLoading(false);
        }
      }
    };

    fetchPreview();

    return () => {
      cancelled = true;
    };
  }, [activeTab, walletEmail, userData?.access_token, id]);

  useEffect(() => {
    if (activeTab !== 3 || !id) return;
    getUserDetails(true);
  }, [activeTab, id, userData?.access_token]);

  useEffect(() => {
    if (activeTab !== 2 || !id) return;
    fetchUserAppActivity(appActivityPage);
  }, [activeTab, id, appActivityPage, userData?.access_token]);



  const getUserRecentVideos = async () => {
    try {
      dispatch(uplodateLoading(true));

      let path = `${urls.userRecentTop3Videos}?userId=${id}&search=${searchText}&status=${statusDropdownText}&mediaType=${mediaDropDownText}&active=${activeInActiveStatus}&page=${page}`;
      let res = await ApiCaller.get({}, path, userData?.access_token, videoApiHeaders);
      const response = await res.response.json();

      if (response?.status == 200 || response?.successful === true) {
        setRecentUserVideos(response?.data || []);
      } else {
        showDangerToast(response?.message || "No recent videos found");
      }
    } catch (error) {
      console.error(error);
      showDangerToast(error.message);
    } finally {
      dispatch(uplodateLoading(false));
    }
  };



  // ✅ tab change handler


  useEffect(() => {
    // This fetch seems to be for a different purpose and uses an unused 'user' state.
    // You may want to review if it's still needed.
    fetch(`/api/users/${id}`)
      .then((res) => res.json())
      .then((data) => setUser(data))
      .catch((err) => console.error("Error fetching user:", err));
  }, [id]);
  // ✅ State for tabs

  // ✅ Tab change handler
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Simplified update function using the correct grade ID
  const handleUpdateGrade = async () => {
    if (selectedGrade === "" || selectedGrade === null) {
      showToast("Please select a grade!");
      return;
    }

    try {
      dispatch(uplodateLoading(true));
      const path = "/api/admin-service/users/grade-update";

      // The body is now simple and correct.
      // selectedGrade already holds the numeric ID.
      const body = {
        userId: id,
        gradeId: selectedGrade,
        updatedBy: userData?.id || userData?.uuid || userData?.emailId || userData?.email
      };

      let res = await ApiCaller.post(body, path, userData?.access_token);
      const response = await res.response.json();

      if (response.status === 200 || response.successful) {
        showToast("Grade updated successfully!");

        // Find the grade's name from the list to update the UI
        const gradeObject = grades.find(g => g.id === selectedGrade);
        setUserDetailsData({
          ...userDetailsData,
          gradeName: gradeObject ? gradeObject.gradeName : '',
          gradeId: selectedGrade
        });
      } else {
        showToast(response.message || "Failed to update grade");
      }
    } catch (error) {
      console.error(error);
      showToast(error.message || "Error updating grade");
    } finally {
      dispatch(uplodateLoading(false));
    }
  };




  const notificationUserLabel =
    userDetailsData?.fullName ||
    userDetailsData?.userName ||
    userDetailsData?.email ||
    'User'

  const whatsAppPhoneNumber =
    `${userDetailsData?.ext || userDetailsData?.extensionNumber || ''} ${userDetailsData?.contactNumber || ''}`.trim()

  return (
    <>
      <SendUserNotificationModal
        show={showNotificationModal}
        onHide={() => setShowNotificationModal(false)}
        userId={id}
        userDisplayName={notificationUserLabel}
      />
      <SendUserWhatsAppModal
        show={showWhatsAppModal}
        onHide={() => setShowWhatsAppModal(false)}
        mode="single"
        userId={id}
        fullName={userDetailsData?.fullName}
        userName={userDetailsData?.userName}
        phoneNumber={whatsAppPhoneNumber}
      />
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>
        <div className='container-fluid mt--7'>
          <div className='row'>
            <div className='col-md-12 text-left'>
              <a
                onClick={() => router("/user-manager", { state: location.state })} // ranith 2025-12-06 - [Start/End] - [Pass state back]
                className='btn btn-sm btn-primary text-white'
              >
                <ReplyIcon />
                Back
              </a>
            </div>
          </div>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', lg: 'row' },
              gap: { xs: 2, lg: 3 },
              alignItems: 'flex-start',
            }}
          >
            {/* Left: Profile — 40% on desktop/laptop */}
            <Box sx={{ width: { xs: '100%', lg: '40%' }, flexShrink: 0 }}>
              {/* Profile Card */}
              <Card sx={{ mb: 3, p: 3 }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<NotificationsActiveIcon />}
                    onClick={() => setShowNotificationModal(true)}
                    disabled={!id}
                    sx={{
                      bgcolor: '#5e72e4',
                      textTransform: 'none',
                      fontWeight: 600,
                      boxShadow: '0 4px 12px rgba(94, 114, 228, 0.3)',
                      '&:hover': { bgcolor: '#4a5fc1' },
                    }}
                  >
                    Send notification
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<WhatsAppIcon />}
                    onClick={() => setShowWhatsAppModal(true)}
                    disabled={!id || !userDetailsData?.contactNumber}
                    sx={{
                      bgcolor: '#25D366',
                      textTransform: 'none',
                      fontWeight: 600,
                      boxShadow: '0 4px 12px rgba(37, 211, 102, 0.3)',
                      '&:hover': { bgcolor: '#1ebe57' },
                    }}
                  >
                    Send WhatsApp
                  </Button>
                  <Button
                    className="btn-primary"
                    sx={{
                      background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
                      color: 'white',
                      boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
                    }}
                    variant="contained"
                    size="small"
                    startIcon={<Grade />}
                  >
                    {userDetailsData?.gradeName ?? '--'}
                  </Button>
                </Box>

                <CardContent sx={{ textAlign: "center", p: 0 }}>
                  <Box sx={{ position: "relative", display: "inline-block", mb: 2 }}>
                    <Avatar
                      src={userDetailsData?.profilePic}
                      sx={{
                        width: 120,
                        height: 120,
                        fontSize: "2rem",
                        fontWeight: "bold",
                      }}
                    >
                      {!userDetailsData?.profilePic &&
                        userDetailsData?.fullName
                          ?.split(" ")
                          .map((n) => n[0])
                          .join("")}
                    </Avatar>
                  </Box>

                  <Typography variant="h5" component="h2" sx={{ fontWeight: "bold", mb: 0.5 }}>

                    <div className='card-header text-center border-0 pt-0 pt-lg-2 pb-4 pb-lg-3'>
                      {userDetailsData?.fullName}
                      {userDetailsData?.isBadged ? <VerifiedIcon /> : <></>}
                    </div>
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: userDetailsData?.dob ? 0.5 : 3 }}
                  >
                    @{userDetailsData?.userName}
                  </Typography>
                  {userDetailsData?.dob && (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 0.75,
                        mb: 2,
                      }}
                    >
                      <Cake sx={{ fontSize: 18, color: 'text.secondary' }} />
                      <Typography variant="body2" color="text.secondary">
                        Born {userDetailsData.dob}
                      </Typography>
                    </Box>
                  )}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexWrap: 'wrap',
                      gap: 1,
                      mb: 3,
                      px: 1,
                    }}
                  >
                    <Select
                      value={selectedGrade}
                      onChange={(e) => setSelectedGrade(e.target.value)}
                      displayEmpty
                      size="small"
                      sx={{ minWidth: { xs: '100%', sm: 150 }, flex: { xs: '1 1 100%', sm: '0 1 auto' } }}
                    >
                      <MenuItem value="">
                        <em>{userDetailsData?.gradeName}</em>
                      </MenuItem>
                      {/* Now we use the proper 'id' for the value */}
                      {grades && grades.map((g) => (
                        <MenuItem key={g.id} value={g.id}>
                          {g.gradeName}
                        </MenuItem>
                      ))}
                    </Select>

                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleUpdateGrade}
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => router(`/grade-change-log?userId=${id}`)}
                    >
                      Grade History
                    </Button>

                  </Box>



                  {userDetailsData?.bio && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 3, px: 1, wordBreak: 'break-word' }}
                    >
                      {userDetailsData.bio}
                    </Typography>
                  )}



                  {/* Main Stats */}
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(4, 1fr)' },
                      gap: { xs: 1.5, sm: 2 },
                      mb: 2,
                      textAlign: 'center',
                    }}
                  >
                    {[
                      { value: userDetailsData?.totalFollowers ?? 0, label: 'Followers' },
                      { value: userDetailsData?.totalFollowing ?? 0, label: 'Following' },
                      { value: userDetailsData?.totalVideos ?? 0, label: 'Videos' },
                      { value: userDetailsData?.totalViews ?? 0, label: 'Total Views' },
                    ].map((stat) => (
                      <Box
                        key={stat.label}
                        sx={{ py: 1.25, px: 0.5, borderRadius: 1, bgcolor: 'action.hover' }}
                      >
                        <Typography sx={profileStatSx.value}>{stat.value}</Typography>
                        <Typography component="span" sx={profileStatSx.label}>
                          {stat.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, 1fr)',
                      gap: { xs: 1, sm: 1.5 },
                      mb: 3,
                      textAlign: 'center',
                    }}
                  >
                    {[
                      { value: userDetailsData?.totalLikes ?? 0, label: 'Likes', format: false },
                      { value: userDetailsData?.rewardChipsBalance, label: 'Reward Chips', format: true },
                      { value: userDetailsData?.totalEarnedChipsBalance, label: 'Earned Chips', format: true },
                    ].map((stat) => (
                      <Box
                        key={stat.label}
                        sx={{ py: 1.25, px: 0.5, borderRadius: 1, bgcolor: 'action.hover', minWidth: 0 }}
                      >
                        <Typography
                          sx={{ ...profileStatSx.value, fontSize: { xs: '0.8rem', sm: '0.95rem' } }}
                        >
                          {stat.format ? formatIndianNumber(stat.value) : stat.value}
                        </Typography>
                        <Typography component="span" sx={profileStatSx.label}>
                          {stat.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </CardContent>
              </Card>

              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5, px: 0.5 }}>
                Contact Information
              </Typography>

              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
              <Card
                sx={{
                  height: '100%',
                  borderRadius: 2,
                  boxShadow: '0 0 2rem 0 rgba(136, 152, 170, 0.15)',
                }}
              >
                <CardContent sx={{ py: 2, '&:last-child': { pb: 2 } }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 2 }}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'rgba(94, 114, 228, 0.12)',
                        color: '#5e72e4',
                        flexShrink: 0,
                      }}
                    >
                      <Email fontSize="small" />
                    </Box>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600}>
                        Email
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-all' }}>
                        {userDetailsData?.email || '—'}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider />
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mt: 2 }}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'rgba(45, 206, 137, 0.12)',
                        color: '#2dce89',
                        flexShrink: 0,
                      }}
                    >
                      <Phone fontSize="small" />
                    </Box>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600}>
                        Mobile
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {`${userDetailsData?.ext || ''} ${userDetailsData?.contactNumber || ''}`.trim() || '—'}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
                </Grid>
                <Grid item xs={12} md={6}>
              <Card
                sx={{
                  height: '100%',
                  borderRadius: 2,
                  boxShadow: '0 0 2rem 0 rgba(136, 152, 170, 0.15)',
                }}
              >
                <CardContent sx={{ py: 2, '&:last-child': { pb: 2 } }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 2 }}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'rgba(251, 99, 64, 0.12)',
                        color: '#fb6340',
                        flexShrink: 0,
                      }}
                    >
                      <AccountCircle fontSize="small" />
                    </Box>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600}>
                        Account Type
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {userDetailsData?.accountType ? `${userDetailsData.accountType} Account` : '—'}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider />
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mt: 2 }}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'rgba(17, 205, 239, 0.12)',
                        color: '#11cdef',
                        flexShrink: 0,
                      }}
                    >
                      <PersonAdd fontSize="small" />
                    </Box>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600}>
                        Invited By
                      </Typography>
                      {getInvitedByUserId() && getInvitedByName() ? (
                        <Typography
                          variant="body2"
                          onClick={() => router(`/user-manager/${getInvitedByUserId()}`)}
                          sx={{
                            fontWeight: 600,
                            color: 'primary.main',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                          }}
                        >
                          {getInvitedByName()}
                        </Typography>
                      ) : (
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {getInvitedByName() || '—'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
                </Grid>
              </Grid>

              <Stack spacing={1.5} sx={{ mb: 3 }}>
                {[
                  {
                    label: 'Chips Balance',
                    value: formatIndianNumber(userDetailsData?.totalChipsBalance),
                    gradient: 'linear-gradient(135deg, #ffd700 0%, #ff8c00 100%)',
                    Icon: EmojiEvents,
                  },
                  {
                    label: 'Creator Chips',
                    value: formatIndianNumber(userDetailsData?.creatorChipsBalance),
                    gradient: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
                    Icon: StarIcon,
                  },
                  {
                    label: 'Cash Wallet',
                    value: `₹${formatIndianNumber(getCashWalletBalance())}`,
                    gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                    Icon: AccountBalanceWallet,
                  },
                ].map((wallet) => (
                  <Card
                    key={wallet.label}
                    sx={{
                      background: wallet.gradient,
                      color: 'white',
                      borderRadius: 2,
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    }}
                  >
                    <CardContent
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        py: 2,
                        px: 2.5,
                        '&:last-child': { pb: 2 },
                      }}
                    >
                      <Box sx={{ minWidth: 0 }}>
                        <Typography
                          variant="caption"
                          sx={{ opacity: 0.9, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}
                        >
                          {wallet.label}
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 700, whiteSpace: 'nowrap', mt: 0.5, fontSize: '1.15rem' }}
                        >
                          {wallet.value}
                        </Typography>
                      </Box>
                      <wallet.Icon sx={{ fontSize: 36, opacity: 0.85, flexShrink: 0, ml: 1 }} />
                    </CardContent>
                  </Card>
                ))}
              </Stack>

            </Box>

            {/* Right: User Info — 60% on desktop/laptop */}
            <Box sx={{ width: { xs: '100%', lg: '60%' }, flex: 1, minWidth: 0 }}>
              {/* Tabs */}
              <Card sx={{ mb: 3 }}>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  indicatorColor="primary"
                  textColor="primary"
                  sx={{
                    '& .MuiTab-root': {
                      minHeight: 48,
                      fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.875rem' },
                      px: { xs: 1, sm: 2 },
                    },
                  }}
                >
                  <Tab label={`Videos (${userDetailsData?.totalVideos || 0})`} value={0} />
                  <Tab label="User Info" value={1} />
                  <Tab label="Activity" value={2} />
                  <Tab label="Bank & Withdrawals" value={3} />
                  <Tab label="Invited Referrals" value={4} />
                  <Tab label="Feed Diagnostics" value={5} />
                </Tabs>
              </Card>

              {/* Tab Content */}

              {activeTab === 0 && (
                <div className="d-flex flex-column gap-4">
                  {recentUserVideos && recentUserVideos.length > 0 ? (
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                          xs: '1fr',
                          sm: 'repeat(2, 1fr)',
                          md: 'repeat(3, 1fr)',
                        },
                        gap: 2,
                      }}
                    >
                      {recentUserVideos.map((video) => (
                        <Card
                          key={video.id}
                          sx={{
                            width: '100%',
                            borderRadius: 2,
                            cursor: video?.link ? 'pointer' : 'default',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            opacity: video?.link ? 1 : 0.7,
                          }}
                          onClick={() => {
                            if (!video?.link) return;
                            const idx = getVideoPlayableList().findIndex((v) => v.id === video.id);
                            if (idx >= 0) openVideoAtIndex(idx);
                          }}
                        >
                          {video?.thumbnail && (
                            <Box
                              sx={{
                                height: 200,
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <img
                                src={video?.thumbnail}
                                alt="Video Thumbnail"
                                style={{ width: '100%', objectFit: 'cover' }}
                              />
                            </Box>
                          )}
                          <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle1" fontWeight="bold" noWrap title={video?.caption || 'Untitled video'}>
                              {video?.caption?.trim() || 'Untitled video'}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Updated: {formatDate(video?.updatedAt || video?.createdAt) || '—'}
                            </Typography>
                            {(video?.languageList?.length > 0 || video?.categoryList?.length > 0) && (
                              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }} noWrap>
                                {[
                                  video?.languageList?.length ? `Lang: ${video.languageList.join(', ')}` : null,
                                  video?.categoryList?.length ? `Category: ${video.categoryList.join(', ')}` : null,
                                ].filter(Boolean).join(' · ')}
                              </Typography>
                            )}
                            <Divider sx={{ my: 1 }} />
                            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                              <Button size="small" startIcon={<Favorite />}>
                                {video?.totalLikes ?? 0}
                              </Button>
                              <Button size="small" startIcon={<Visibility />}>
                                {video?.totalViews ?? 0}
                              </Button>
                              <Button size="small" startIcon={<Comment />}>
                                {video?.totalComments ?? 0}
                              </Button>
                            </Box>
                          </CardContent>
                        </Card>
                      ))}
                    </Box>
                  ) : (
                    <Typography variant="body2" color="text.secondary" textAlign="center">
                      No videos uploaded yet.
                    </Typography>
                  )}

                  <Button
                    variant="contained"
                    onClick={() => {
                      // alert('Navigating to Video Manager with userDetailsData: ' + userDetailsData?.userName);
                      router('/video-manager', { state: { userId: userDetailsData?.userName } }); // send userId
                    }}
                  >
                    All Videos
                  </Button>








                </div>
              )}





              {activeTab === 1 && (
                <>
                  {/* User Information */}
                  <Card sx={{ p: 3, mb: 3 }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                        User Information
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Full Name
                          </Typography>
                          <Typography variant="body1">{userDetailsData?.fullName}</Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Gender
                          </Typography>
                          <Typography variant="body1">{userDetailsData?.gender}</Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Date Of Birth
                          </Typography>
                          <Typography variant="body1">{userDetailsData?.dob}</Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Date Of Registration
                          </Typography>
                          <Typography variant="body1">
                            {new Date(userDetailsData?.createdAt).toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                            })}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Exclusive Enable
                          </Typography>
                          <Typography variant="body1">
                            {userDetailsData?.exclusiveEnable ? "Enabled" : "Disabled"}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Account Type
                          </Typography>
                          <Typography variant="body1">{userDetailsData?.accountType}</Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Register Via
                          </Typography>
                          <Typography variant="body1">{userDetailsData?.signInType}</Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Total Chips
                          </Typography>
                          <Typography variant="body1">{formatIndianNumber(userDetailsData?.totalChipsBalance)}</Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Cash Wallet Balance
                          </Typography>
                          <Typography variant="body1">
                            ₹{formatIndianNumber(getCashWalletBalance())}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Invited By
                          </Typography>
                          <Typography variant="body1">{getInvitedByName() || '—'}</Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            Country
                          </Typography>
                          <Typography variant="body1">{userDetailsData?.countryName || "--"}</Typography>
                        </Box>

                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            State
                          </Typography>
                          <Typography variant="body1">{userDetailsData?.stateName || "--"}</Typography>
                        </Box>
                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            District
                          </Typography>
                          <Typography variant="body1">{userDetailsData?.districtName || "--"}</Typography>
                        </Box>
                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">
                            City
                          </Typography>
                          <Typography variant="body1">{userDetailsData?.cityName || "--"}</Typography>
                        </Box>

                       

                        {/* <Box sx={{ flexBasis: "100%" }}>
                          <Typography variant="subtitle2" color="text.secondary">
                            Category
                          </Typography>
                          <Typography variant="body1">
                            {userDetailsData?.userPreferredTags?.join(", ") || "None"}
                          </Typography>
                        </Box> */}
                      </Box>
                    </CardContent>
                  </Card>

                  {/* Videos Table */}
                  <Card sx={{ p: 3, mb: 3 }}>
                    <CardContent sx={{ p: 0 }}>
                      <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
                        Recent Videos
                      </Typography>

                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Thumbnail</TableCell>
                              <TableCell>Caption</TableCell>
                              <TableCell>Views</TableCell>
                              <TableCell>Likes</TableCell>
                              <TableCell>Comments</TableCell>
                              <TableCell>Updated</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {recentUserVideos?.map((video) => (
                              <TableRow key={video.id} hover>
                                <TableCell>
                                  <img
                                    src={video.thumbnail}
                                    alt="thumbnail"
                                    style={{
                                      width: 100,
                                      height: 60,
                                      objectFit: "cover",
                                      borderRadius: 8,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      const idx = getVideoPlayableList().findIndex((v) => v.id === video.id);
                                      if (idx >= 0) openVideoAtIndex(idx);
                                    }}
                                  />
                                </TableCell>
                                <TableCell>{video.caption || '—'}</TableCell>
                                <TableCell>
                                  <Visibility sx={{ color: "primary.main", verticalAlign: "middle", fontSize: 18 }} />{" "}
                                  {video.totalViews ?? 0}
                                </TableCell>
                                <TableCell>
                                  <Favorite sx={{ color: "red", verticalAlign: "middle" }} />{" "}
                                  {video.totalLikes ?? 0}
                                </TableCell>
                                <TableCell>
                                  <Comment sx={{ color: "blue", verticalAlign: "middle" }} />{" "}
                                  {video.totalComments ?? 0}
                                </TableCell>
                                <TableCell>
                                  {formatDate(video.updatedAt || video.createdAt) || '—'}
                                </TableCell>
                              </TableRow>
                            ))}

                            {!recentUserVideos?.length && (
                              <TableRow>
                                <TableCell colSpan={6} align="center">
                                  No recent videos found.
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </CardContent>
                  </Card>

                  {/* Categories */}
                  <Card sx={{ p: 3 }}>
                    <CardContent sx={{ p: 0 }}>
                      <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
                        Interest Categories
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {userDetailsData?.userPreferredTags?.map((tag, index) => (
                          <Chip
                            key={index}
                            label={tag}
                            variant="outlined"
                            color="primary"
                            sx={{
                              "&:hover": {
                                backgroundColor: "primary.light",
                                color: "white",
                              },
                            }}
                          />
                        ))}
                      </Box>
                    </CardContent>
                  </Card>

                </>
              )}



              {activeTab === 2 && (
                <>
                <Card sx={{ p: 3, mb: 3 }}>
                  <CardContent sx={{ p: 0 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3 }}>
                      <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold' }}>
                        App Usage Time
                      </Typography>
                      <Chip
                        icon={<AccessTime sx={{ fontSize: 18 }} />}
                        label={`Total: ${formatAppTimeParts(appActivityTotalTime)}`}
                        color="primary"
                        variant="outlined"
                        sx={{ fontWeight: 700 }}
                      />
                    </Box>

                    {appActivityLoading ? (
                      <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ py: 4 }}>
                        Loading app activity...
                      </Typography>
                    ) : appActivityItems.length > 0 ? (
                      <>
                        <TableContainer component={Paper} variant="outlined">
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 700 }}>Date</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Time Spent</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Last Active</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {appActivityItems.map((row, index) => (
                                <TableRow key={`${row.activityDate}-${index}`} hover>
                                  <TableCell>
                                    {row.activityDate
                                      ? formatDate(row.activityDate)
                                      : '—'}
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: 600 }}>
                                    {formatAppTimeParts(row.displayTime)}
                                    {row.totalMinutesSpent != null && (
                                      <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                                        ({row.totalMinutesSpent} min)
                                      </Typography>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {row.lastActivityAt
                                      ? formatDateTime(row.lastActivityAt)
                                      : '—'}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        {appActivityPagination.totalPages > 1 && (
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                            <Typography variant="caption" color="text.secondary">
                              Page {appActivityPagination.pageNumber + 1} of {appActivityPagination.totalPages}
                              {' · '}
                              {appActivityPagination.totalItems} day(s)
                            </Typography>
                            <ButtonGroup size="small" variant="outlined">
                              <Button
                                disabled={appActivityPage <= 0 || appActivityLoading}
                                onClick={() => setAppActivityPage((p) => Math.max(0, p - 1))}
                              >
                                Previous
                              </Button>
                              <Button
                                disabled={
                                  appActivityLoading ||
                                  appActivityPage >= appActivityPagination.totalPages - 1
                                }
                                onClick={() => setAppActivityPage((p) => p + 1)}
                              >
                                Next
                              </Button>
                            </ButtonGroup>
                          </Box>
                        )}
                      </>
                    ) : (
                      <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ py: 4 }}>
                        No app usage recorded for this user yet.
                      </Typography>
                    )}
                  </CardContent>
                </Card>

                <Card sx={{ p: 3 }}>
                  <CardContent sx={{ p: 0 }}>
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{ mb: 3, fontWeight: "bold" }}
                    >
                      Account Activity
                    </Typography>
                    <div className="d-flex flex-column gap-3">
                      <Paper sx={{ p: 2, bgcolor: "grey.50" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                          <Typography variant="body1" color="text.secondary">
                            Registration Date
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            {new Date(userDetailsData?.createdAt).toLocaleDateString()}
                          </Typography>
                        </Box>
                      </Paper>
                      <Paper sx={{ p: 2, bgcolor: "grey.50" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                          <Typography variant="body1" color="text.secondary">
                            Registered Via
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            {userDetailsData?.signInType}
                          </Typography>
                        </Box>
                      </Paper>
                      <Paper sx={{ p: 2, bgcolor: "grey.50" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                          <Typography variant="body1" color="text.secondary">
                            User ID
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            #{userDetailsData?.chatUserId}
                          </Typography>
                        </Box>
                      </Paper>
                      <Paper sx={{ p: 2, bgcolor: "grey.50" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                          <Typography variant="body1" color="text.secondary">
                            Account Status
                          </Typography>
                          <Chip label="Active" color="success" size="small" />
                        </Box>
                      </Paper>
                    </div>
                  </CardContent>
                </Card>
                </>
              )}
              {activeTab === 3 && (
                <>
                  {/* ADDED: Bank & Withdrawals tab preview (Beads + Cash) */}
                  <Card sx={{ p: 3, mb: 3 }}>
                    <CardContent sx={{ p: 0 }}>
                      <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                        Beads (Chips) - Recent Transactions (Last 10)
                      </Typography>

                      <div className="table-responsive">
                        <table className="table align-items-center table-flush">
                          <thead className="thead-light">
                            <tr>
                              <th>#</th>
                              <th>Type</th>
                              <th style={{ backgroundColor: 'rgba(34, 197, 94, 0.15)' }}>Received</th>
                              <th style={{ backgroundColor: 'rgba(239, 68, 68, 0.15)' }}>Paid</th>
                              <th>Date</th>
                              <th>Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {chipsTxnPreviewLoading ? (
                              <tr>
                                <td colSpan={6} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : chipsTxnPreview && chipsTxnPreview.length > 0 ? (
                              chipsTxnPreview.map((item, idx) => {
                                const received = isReceivedTxn(item);
                                const amount = getTxnAmount(item);
                                const rowStyle = received
                                  ? { backgroundColor: 'rgba(34, 197, 94, 0.08)' }
                                  : { backgroundColor: 'rgba(239, 68, 68, 0.08)' };

                                return (
                                  <tr key={idx} style={rowStyle}>
                                    <td>{idx + 1}</td>
                                    <td>{item?.transactionType || item?.type || '-'}</td>
                                    <td style={{ color: received ? '#15803d' : undefined, fontWeight: received ? 600 : undefined }}>
                                      {received ? amount : '-'}
                                    </td>
                                    <td style={{ color: !received ? '#b91c1c' : undefined, fontWeight: !received ? 600 : undefined }}>
                                      {!received ? amount : '-'}
                                    </td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{(item?.createdAt || item?.createdDate || item?.date) ? formatDateTime(item?.createdAt || item?.createdDate || item?.date) : '-'}</td>
                                    <td>{item?.txnNote || item?.description || '-'}</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={6} className="text-center">
                                  No Data Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      <Box mt={2} display="flex" justifyContent="flex-end">
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => router(`/view-chips-wallet-history?email=${encodeURIComponent(walletEmail)}`)}
                          disabled={!walletEmail}
                        >
                          View All
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>

                  <Card sx={{ p: 3, mb: 3 }}>
                    <CardContent sx={{ p: 0 }}>
                      <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                        Cash - Recent Transactions (Last 10)
                      </Typography>

                      <div className="table-responsive">
                        <table className="table align-items-center table-flush">
                          <thead className="thead-light">
                            <tr>
                              <th>#</th>
                              <th>Type</th>
                              <th style={{ backgroundColor: 'rgba(34, 197, 94, 0.15)' }}>Received</th>
                              <th style={{ backgroundColor: 'rgba(239, 68, 68, 0.15)' }}>Paid</th>
                              <th>Date</th>
                              <th>Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cashTxnPreviewLoading ? (
                              <tr>
                                <td colSpan={6} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : cashTxnPreview && cashTxnPreview.length > 0 ? (
                              cashTxnPreview.map((item, idx) => {
                                const received = isReceivedTxn(item);
                                const amount = getTxnAmount(item);
                                const rowStyle = received
                                  ? { backgroundColor: 'rgba(34, 197, 94, 0.08)' }
                                  : { backgroundColor: 'rgba(239, 68, 68, 0.08)' };

                                return (
                                  <tr key={idx} style={rowStyle}>
                                    <td>{idx + 1}</td>
                                    <td>{item?.transactionType || item?.type || '-'}</td>
                                    <td style={{ color: received ? '#15803d' : undefined, fontWeight: received ? 600 : undefined }}>
                                      {received ? amount : '-'}
                                    </td>
                                    <td style={{ color: !received ? '#b91c1c' : undefined, fontWeight: !received ? 600 : undefined }}>
                                      {!received ? amount : '-'}
                                    </td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{(item?.createdAt || item?.createdDate || item?.date) ? formatDateTime(item?.createdAt || item?.createdDate || item?.date) : '-'}</td>
                                    <td>{item?.txnNote || item?.description || '-'}</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={6} className="text-center">
                                  No Data Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      <Box mt={2} display="flex" justifyContent="flex-end">
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => router(`/view-cash-wallet-history?email=${encodeURIComponent(walletEmail)}`)}
                          disabled={!walletEmail}
                        >
                          View All
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>

                  <Card sx={{ p: 3, mb: 3 }}>
                    <CardContent sx={{ p: 0 }}>
                      <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                        Bank Withdrawals - Recent Requests (Last 10)
                      </Typography>

                      <div className="table-responsive">
                        <table className="table align-items-center table-flush">
                          <thead className="thead-light">
                            <tr>
                              <th>#</th>
                              <th>Type</th>
                              <th>Transaction ID</th>
                              <th style={{ backgroundColor: 'rgba(34, 197, 94, 0.15)' }}>Received</th>
                              <th style={{ backgroundColor: 'rgba(239, 68, 68, 0.15)' }}>Paid</th>
                              <th>Date</th>
                              <th>Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bankTxnPreviewLoading ? (
                              <tr>
                                <td colSpan={7} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : bankTxnPreview && bankTxnPreview.length > 0 ? (
                              bankTxnPreview.map((item, idx) => {
                                const paidAmountVal =
                                  item?.finalAmount !== undefined && item?.finalAmount !== null
                                    ? Number(item?.finalAmount)
                                    : item?.requestedAmount !== undefined && item?.requestedAmount !== null
                                      ? Number(item?.requestedAmount)
                                      : 0;
                                const paidAmount = formatIndianNumber(paidAmountVal);
                                return (
                                  <tr
                                    key={item?.id || idx}
                                    style={{ backgroundColor: 'rgba(239, 68, 68, 0.08)' }}
                                  >
                                    <td>{idx + 1}</td>
                                    <td>{item?.status || 'PENDING'}</td>
                                    <td style={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>{getWithdrawTxnId(item)}</td>
                                    <td style={{ color: undefined, fontWeight: undefined }}>-</td>
                                    <td style={{ color: '#b91c1c', fontWeight: 600 }}>{paidAmount}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{(item?.createdAt || item?.createdDate || item?.date) ? formatDateTime(item?.createdAt || item?.createdDate || item?.date) : '-'}</td>
                                    <td>{item?.remarks || item?.bankName || '-'}</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={7} className="text-center">
                                  No Data Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      <Box mt={2} display="flex" justifyContent="flex-end">
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => router(`/user-bank-withdraw-history/${id}`)}
                          disabled={!id}
                        >
                          View All
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>

                  {/* Withdrawal Statistics */}
                  <Card sx={{ p: 3, mb: 3 }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
                        Withdrawal Statistics
                      </Typography>
                      <div className="row g-3">
                        <div className="col-md-3">
                          <Card sx={{ bgcolor: '#f8f9fa' }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">Total Withdrawal</Typography>
                              <Typography variant="h6" fontWeight="bold">₹{formatIndianNumber(userDetailsData?.totalWithdrawalAmount || 0)}</Typography>
                            </CardContent>
                          </Card>
                        </div>
                        <div className="col-md-3">
                          <Card sx={{ bgcolor: '#e8f5e9' }}> {/* Light Green */}
                            <CardContent>
                              <Typography variant="subtitle2" color="success.main">Paid Amount</Typography>
                              <Typography variant="h6" fontWeight="bold" color="success.main">₹{formatIndianNumber(userDetailsData?.paidWithdrawalAmount || 0)}</Typography>
                            </CardContent>
                          </Card>
                        </div>
                        <div className="col-md-3">
                          <Card sx={{ bgcolor: '#fff3e0' }}> {/* Light Orange */}
                            <CardContent>
                              <Typography variant="subtitle2" color="warning.main">Pending Amount</Typography>
                              <Typography variant="h6" fontWeight="bold" color="warning.main">₹{formatIndianNumber(userDetailsData?.pendingWithdrawalAmount || 0)}</Typography>
                            </CardContent>
                          </Card>
                        </div>
                        <div className="col-md-3">
                          <Card sx={{ bgcolor: '#ffebee' }}> {/* Light Red */}
                            <CardContent>
                              <Typography variant="subtitle2" color="error.main">Rejected Amount</Typography>
                              <Typography variant="h6" fontWeight="bold" color="error.main">₹{formatIndianNumber(userDetailsData?.rejectedWithdrawalAmount || 0)}</Typography>
                            </CardContent>
                          </Card>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                  {/* Bank Information */}
                  {/* <Card sx={{ p: 3, mb: 3 }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                        Bank Information
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">Bank Name</Typography>
                          <Typography variant="body1" fontWeight="medium">{userDetailsData?.bankName || "--"}</Typography>
                        </Box>
                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">Account Number</Typography>
                          <Typography variant="body1" fontWeight="medium">{userDetailsData?.accountNumber || userDetailsData?.bankAccount || "--"}</Typography>
                        </Box>
                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">IFSC Code</Typography>
                          <Typography variant="body1" fontWeight="medium">{userDetailsData?.ifscCode || userDetailsData?.ifsc || "--"}</Typography>
                        </Box>
                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">Account Holder</Typography>
                          <Typography variant="body1" fontWeight="medium">{userDetailsData?.accountHolderName || userDetailsData?.accountHolder || "--"}</Typography>
                        </Box>
                        <Box>
                          <Typography variant="subtitle2" color="text.secondary">UPI ID</Typography>
                          <Typography variant="body1" fontWeight="medium">{userDetailsData?.upiId || "--"}</Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card> */}
                </>
              )}
              {activeTab === 5 && (
                <UserFeedDiagnostics
                  userId={id}
                  accessToken={userData?.access_token}
                  enabled={activeTab === 5}
                />
              )}
              <Card sx={{ p: { xs: 2, sm: 3 }, mb: 3, display: activeTab === 4 ? 'block' : 'none' }}>
                <CardContent sx={{ p: 0 }}>
                  <InvitedUserList
                    userId={id}
                    referralCode={referralCodes.referralCode}
                    inviteType={null}
                    enabled={activeTab === 4}
                    referralCodeLoading={referralCodesLoading}
                    invitedByName={getInvitedByName()}
                    invitedByUserId={getInvitedByUserId()}
                  />
                  {/* Creator Invited Users — disabled (no UI, no API fetch)
                  <ButtonGroup variant="outlined" size="small">
                    <Button onClick={() => setInvitedListType('CREATERINVITE')}>
                      Creator Invited Users
                    </Button>
                  </ButtonGroup>
                  <InvitedUserList
                    userId={id}
                    referralCode={getReferralCodeForInviteType(referralCodes, 'CREATERINVITE')}
                    inviteType="CREATERINVITE"
                    enabled={activeTab === 4}
                    referralCodeLoading={referralCodesLoading}
                  />
                  */}
                </CardContent>
              </Card>
            </Box>
          </Box>


        </div>

        {/* Modals */}
        <PlayVideoInModal
          videoSrc={videoSrc}
          show={showPlayVideoModal}
          onHide={closeVideoModal}
          videos={getVideoPlayableList()}
          currentIndex={activeVideoIndex}
          onIndexChange={handleVideoIndexChange}
          getVideoLabel={(video) => video?.caption || video?.title || 'Video'}
        />
        <FullImageView
          src={imageUrl}
          show={fullSizePreview}
          onHide={() => setFullSizePreview(false)}
        />
      </div>
    </>
  );
};